import React from 'react';
import {connect} from 'react-redux'

import {Link} from "react-router-dom";
import * as actions from '../../../store/actions'
import Input from "../../theme/forms/Input";
import api from "../../../store/api";
import PublicTopNav from "../../theme/nav/PublicTopNav";
import BaseHomePageLogoWrapper from "../../theme/logoCards/baseHomePageLogoWrapper"


import {isUserLoggedIn} from "../../../utils/session/logout";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import BaseModal from "../../theme/modals/BaseModal";
import MapFrame from "../../theme/maps/mapFrame";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";
import {getSubdomain} from "../../../utils/general"
import {projectStartSearch} from "../../../utils/projectStartSearch"


// theme componenets
import CFTitle from "../../theme/cfPublic/CFTitle";
import TelephoneNumber from "../../subcomponents/TelephoneNumber";
import ContactEmail from "../../subcomponents/ContactEmail";
import AlertFeed from "../../theme/alerts/alertFeed";


class HomePage extends React.Component {


    constructor(props) {
        super(props);

        let randomBGInt = () => {
            let r = Math.random()
            if (r < .34) {
                return 1
            } if (r < .67) {
                return 2
            } 
                return 3
            
        }

        this.state = {
            property_address_value: null,
            error: null,
            bgInt: randomBGInt(),
            displayMap: false,
            showOnlyProgramsWithFunders: true

        }

        // working default
        this.defaultGeojson = {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "feature",
                    "geometry": {
                        "type": "MultiPolygon",
                        "coordinates": [
                        ]
                    }
                }
            ]
        }

        this.mapGeojson = this.defaultGeojson;

    }


    componentDidMount() {
        toggleGlobalLoader(false);
    }

    handleAddressFormSubmit = synEvent => {
        synEvent.preventDefault();
        // this.checkProgramsForAddress();
        window.gtag('event', 'search', {'search_term': this.state.property_address_value})
        projectStartSearch(this.state.property_address_value, this.props.history)
            .catch((err) => {
                if (err.response) {
                    addErrorAlert("That address didn't seem to work. Would you like to try another?")
                    console.log("BAD RESPONSE ALERT")
                } else {
                    console.log("NO RESPONSE ALERT")
                    addErrorAlert("Seems to be that we're having trouble reaching our servers.")
                }
            })
    }



    loadAndOpenMap = () => {
        toggleGlobalLoader(true);

        api.get('/country-geojson/', {wfunders: this.state.showOnlyProgramsWithFunders ? 1 : null})
            .then(res => {
                this.mapGeojson = res.data;
                this.setState({displayMap: false}, () => this.setState({displayMap: true})); // off before on as security and to ensure update
            })
            .catch(err => addErrorAlert("Something's not right. We had a problem getting the map data."))
            .finally(() => toggleGlobalLoader(false))
    };

    closeAndClearMap = () => {
        this.setState({displayMap: false})
    }


    render() {

        return (
            <div id="homepage-wrapper">
                <section className="hero" id="homepage-hero">
                    <div id="start"/>
                    <PublicTopNav/>
                    <div className="hero-body" >
                        <div className="main-home-container" >
                            {/* style={{backgroundColor: "rgba(255,255,255, .5)"}} */}
                            <div className="title has-text-primary has-text-weight-bold is-size-3-mobile is-size-1">
                                Get instant financing options for your green commercial building improvement.
                            </div>
                            <div className="subtitle my-6">
                                Let's start. What is the project address or business name and city?
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                                <div >
                                    <form onSubmit={this.handleAddressFormSubmit} className="main-home-form">
                                        <div className="main-home-input">
                                            <Input
                                                type="text"
                                                placeholder="📍 ENTER PROPERTY ADDRESS"
                                                value={this.state.property_address_value}
                                                onChange={val => this.setState({property_address_value: val, property_address_error: false})}
                                            />
                                        </div>
                                        <div className="main-home-input">
                                            <button type='submit' className="button is-primary  has-text-weight-semibold">
                                                Start Your Project
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="input-error has-text-danger"
                                     style={{opacity: this.state.error ? 1 : 0}}>
                                    {this.state.error || ''}
                                </div>
                            </div>

                            <p className="mt-4 has-text-grey">You'll be required to create an account before seeing your financing options.<br/>
                                <Link to="/create-account"> You can create an account now</Link> or follow our step by step process. </p>

                            <div className="mt-4 is-flex">

                                <button className="button is-text has-text-primary pl-0"
                                        onClick={this.loadAndOpenMap}
                                >
                                    See CleanFi's PACE Markets
                                </button>
                            </div>

                            <BaseHomePageLogoWrapper/>
                        </div>
                    </div>


                </section>

                <section className="hero contrast-gradient-330-deg" id="what-we-finance">
                    <div className="hero-body " >
                        {/* <div className={'title mb-6 has-text-primary'}>3 Simple Steps to Finance your commercial improvement</div> */}
                        <div className="main-home-container">
                        <div className="mb-5">
                            <h3 className="is-size-3 has-text-primary"><span className="has-text-weight-bold">Step 1</span>  Enter your commercial or multi-family residential building address in the form above</h3>
                            <p className="is-size-5">CleanFi maps your address to our national database of funders to get you the best possible financing for your product</p>
                        </div>

                        <div className="mb-5">
                            <h3 className="is-size-3 has-text-primary "><span className="has-text-weight-bold">Step 2</span>  Tell us about your property and project</h3>
                            <p className="is-size-5">You tell us what sort of improvements you want to make, when you want to start, and how much you need to make your project happen so we can provide an instant and accurate financing estimate. </p>
                        </div>
                        <div className="mb-5">
                            <h3 className="is-size-3 has-text-primary "><span className="has-text-weight-bold">Step 3</span>  Apply for the loan that looks best for you.</h3>
                            <p className="is-size-5"> Review the real time financing quotes we provide for your solution, and then go through the rest of them. </p>
                        </div>
                        </div>
                    </div>
                </section>

                {/*  what we finance */}
                <section className="hero contrast-gradient-15-deg" id="what-we-finance">
                    <div className="hero-body" >

                        <div className="title mb-6 has-text-primary">Available Products</div>
                        <div className="icon-name-box-wrapper">

                            <div className="icon-name-box box  ">
                                <img
                                    src="https://statichouse.pacefi.com/img/icons/products/house_filled.png"
                                    height="80px"
                                />
                                <h4>PACE</h4>
                            </div>

                            <div className="icon-name-box box  ">
                                <img
                                    src="https://statichouse.pacefi.com/img/icons/products/double_highrise.png"
                                    height="80px"
                                />
                                <h4>PPAs</h4>
                            </div>

                            <div className="icon-name-box box  ">
                                <img
                                    src="https://statichouse.pacefi.com/img/icons/products/pump.png"
                                    height="80px"
                                />
                                <h4>Capital Leases</h4>
                            </div>


                            <div className="icon-name-box box  ">
                                <img
                                    src="https://statichouse.pacefi.com/img/icons/products/lightbulb_graph.png"
                                    height="80px"
                                />
                                <h4>Tax Equity</h4>
                            </div>
                        </div>
                    </div>
                </section>

                {/* contact */}
                <section className="hero " id="call us">
                    <div className="contact-home">
                        <div className="contact-home__wrapper">
                            <div className="contact-home__msg">
                                <p className="msg__call"><a href="#start">Start your project!</a> <br/>
                                    Call us if you have any questions.</p>
                                <div className="msg__contact">
                                    <p><TelephoneNumber className="msg__contact__number"/></p>
                                    <p><ContactEmail className="msg__contact__email "/></p>
                                </div>
                            </div>

                            <div className="contact-home__img">
                                <img src="https://statichouse.pacefi.com/img/contractor_w_hard_hat.png"/>
                            </div>
                        </div>
                        <div className="contact-home__contrast-bar"/>
                    </div>

                </section>





                {/* <section className="hero has-background-link-dark"> */}
                {/*    <div className={"hero-body"}> */}
                {/*        <div className={'title'}> */}
                {/*            We help make buildings resilient, green, and healthy to occupy by making the financing of these upgrades as easy as possible. */}
                {/*        </div> */}
                {/*    </div> */}
                {/* </section> */}

                {/* <section className="hero" id={'mail-signup'}> */}
                {/*    <div className="hero-body"> */}
                {/*        <div className={'cc-contact-form'}> */}
                {/*            <div class="ctct-inline-form" data-form-id="9dccc015-3a21-41a1-9945-dfa717fed01d"/> */}
                {/*        </div> */}
                {/*    </div> */}
                {/* </section> */}



                {this.state.displayMap &&
                    <BaseModal
                        visible
                        cardStyle={{width: 1040, height: 840,  display: 'flex', justifyContent: 'center'}}
                    >
                        <div className="has-background-white">
                            <MapFrame
                                geojsonData={this.mapGeojson}
                                polygonFill={this.state.showOnlyProgramsWithFunders ? '#A0DF00' : '#1C4E89'}
                            />
                            <div className="buttons are-small p-4">
                                <button className={`button ${this.state.showOnlyProgramsWithFunders ? 'is-primary' : ''}`}
                                        onClick={() => {
                                            if (this.state.showOnlyProgramsWithFunders) return;
                                            this.setState({showOnlyProgramsWithFunders: true}, this.loadAndOpenMap)
                                        }}
                                >
                                    Programs on CleanFi
                                </button>
                                <button className={`button ${this.state.showOnlyProgramsWithFunders ? '' : 'is-primary'}`}
                                        onClick={() => {
                                            if (!this.state.showOnlyProgramsWithFunders) return;
                                            this.setState({showOnlyProgramsWithFunders: false}, this.loadAndOpenMap)
                                        }}
                                >
                                    Areas with Pace Programs
                                </button>
                            </div>
                        </div>
                        <button onClick={this.closeAndClearMap} className="modal-close is-large" aria-label="close"/>
                    </BaseModal>
                }
                <PacefiFullScreenSpinner/>
                <div id="admin-wrapper-alert-feed">
                    <AlertFeed />
                </div>
            </div>

        )
    }

}


const mapStateToProps = state => ({
    subdomainInfo: state.session.subdomainInfo,
})

const mapDispatchToProps = dispatch => ({
    updateProjectInputs: data => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    updateProjectComputed: data => dispatch(actions.formFlow.updateFormFlowComputed(data)),
    clearFormFlow: data => dispatch(actions.formFlow.clearFormFlow()),
    setFocusedProject: data => dispatch(actions.projectLeads.setFocusedProject()),
    updateInfoFeedDisplay: data => dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
    clearInfoFeedDisplay: data => dispatch(actions.infoFeed.clearInfoFeedDisplay()),
})


export default connect(mapStateToProps, mapDispatchToProps)(HomePage)



